import React from 'react';
import { Card, Collapse } from 'reactstrap';
import { formatTimestamp } from '../../../helpers/formatter';
import PickupDetailsReview from './DirectComponents/PickupDetailsReview';
import DropoffDetailsReview from './DirectComponents/DropoffDetailsReview';
import DefaultItemsDescription from './DirectComponents/DefaultItemsDescription';
import ShipmentDescription from './DirectComponents/ShipmentDescription';
import ConfirmButtons from './DirectComponents/ConfirmButtons';
import BillingInfoReview from './DirectComponents/BillingInfoReview';

const RegularConfirmPage = ({
  showForm3,
  pickupInfo,
  pickupInstruction,
  merchantOrderID,
  vehicleType,
  numPeople,
  scheduledFor,
  isExpedited,
  isScheduled,
  handleBack,
  price,
  handleConfirmRegular,
  setIsSaved,
  setOrderStatus,
  setShipmentStatus,
  dropoffInfo,
  dropoffInstruction,
  defaultItems,
  priceRangeLow,
  priceRangeHigh,
  quoteLineItems,
  isInvoice,
  billingInfo
}) => {
  return (
    <Collapse isOpen={showForm3} style={{ backgroundColor: '#27293d' }}>
      <Card style={{ backgroundColor: '#27293d', color: '#fff' }} className="card-form">
        <form className="dropship-container" autoComplete="off" style={{ padding: `100px` }}>
          <div>
            <div style={{ marginBottom: 15, marginTop: 25, fontSize: 15, color: '#f7941d' }}>
              Review your order
              <hr style={{ backgroundColor: '#344675' }} />
            </div>
            {isInvoice && (
              <div>
                <BillingInfoReview billingInfo={billingInfo} />
                <hr style={{ backgroundColor: '#344675' }} />
              </div>
            )}
            <div>
              <PickupDetailsReview pickupInfo={pickupInfo} pickupInstruction={pickupInstruction} />
              <hr style={{ backgroundColor: '#344675' }} />
            </div>

            <div>
              <DropoffDetailsReview dropoffInfo={dropoffInfo} dropoffInstruction={dropoffInstruction} />
              <hr style={{ backgroundColor: '#344675' }} />
            </div>
            <div>
              <div style={{ color: '#fff', fontStyle: 'bold' }}>Shipment Description</div>
              <DefaultItemsDescription defaultItems={defaultItems} />
              <ShipmentDescription
                merchantOrderID={merchantOrderID}
                vehicleType={vehicleType}
                numPeople={numPeople}
                scheduledFor={scheduledFor}
                formatTimestamp={formatTimestamp}
              />
              <hr style={{ backgroundColor: '#344675' }} />
            </div>
          </div>
          <ConfirmButtons
            isExpedited={isExpedited}
            price={price}
            isScheduled={isScheduled}
            handleBack={handleBack}
            handleConfirm={handleConfirmRegular}
            setIsSaved={setIsSaved}
            setOrderStatus={setOrderStatus}
            setShipmentStatus={setShipmentStatus}
            vehicleType={vehicleType}
            priceRangeLow={priceRangeLow}
            priceRangeHigh={priceRangeHigh}
            quoteLineItems={quoteLineItems}
          />
        </form>
      </Card>
    </Collapse>
  );
};

export default RegularConfirmPage;
